"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Prices = void 0;
var _productBox = require("@ori/product-box");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _contexts = require("../../contexts");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Prices = () => {
  const {
    price,
    code
  } = (0, _contexts.useSearchPreviewProduct)();
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  if (!price?.currentFormatted) {
    return null;
  }
  const {
    currentFormatted,
    oldFormatted
  } = price;
  const oldPriceVisible = (0, _productBox.isOldPriceVisible)({
    currentFormatted,
    old: oldFormatted
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    "data-testid": getTestId(`${_constants.PRODUCT_PRICES}-${code}`),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CurrentPrice, {
      fontWeight: "bold",
      oldPriceVisible: oldPriceVisible,
      children: currentFormatted
    }), oldPriceVisible ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.OldPrice, {
      children: oldFormatted
    }) : null]
  });
};
exports.Prices = Prices;
//# sourceMappingURL=Prices.js.map